module.exports = __webpack_public_path__ + "images/980c21f1.jpg";